import React from "react";
import {BrowserRouter, Switch, Route} from "react-router-dom";
import {NewsLayout} from "./layout";
import {Home, News, Projects, About, NotFound} from "./pages";
import {ScrollToTop} from "./components";

function App() {
  return (
    <BrowserRouter>
        <ScrollToTop />
        <NewsLayout>
            <Switch>
                <Route exact path="/">
                  <Home/>
                </Route>
                <Route exact path="/news">
                    <News/>
                </Route>
                <Route exact path="/projects">
                    <Projects/>
                </Route>
                <Route exact path="/about">
                    <About/>
                </Route>
                <Route path="*">
                    <NotFound/>
                </Route>
            </Switch>
        </NewsLayout>
    </BrowserRouter>
  );
}

export default App;
